import { render, staticRenderFns } from "./MenuList.vue?vue&type=template&id=3286cbf8&scoped=true&"
var script = {}
import style0 from "./MenuList.vue?vue&type=style&index=0&id=3286cbf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3286cbf8",
  null
  
)

export default component.exports